export default "__VITE_ASSET__6c66dbf4__"